function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';
import _progress from "./../../progress/progress.react.js";

var Progress = _progress.applyDecls();

import "./../../progress/progress.css";
export default decl({
  block: 'header2',
  elem: 'progress',
  render: function render() {
    var _this$props = this.props,
        timing = _this$props.timing,
        value = _this$props.value;
    return React.createElement(Progress, _extends({
      timing: timing,
      value: value
    }, {
      mix: {
        block: 'header2',
        elem: 'progress'
      }
    }));
  }
});